<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAttachments"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-full w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 md:w-10/12 w-full h-screen overflow-y-auto"
        >
          <!-- Loader -->
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <!-- Close -->
          <div class="flex justify-end border-b-1.5 p-3">
            <img
              class="h-6 cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close"
            />
          </div>

          <!-- Error -->
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <!-- Title -->
          <div class="m-2">
            <p class="text-base font-bold">
              {{ docTitle ? docTitle : 'Attachment' }}
            </p>
          </div>

          <!-- VIEWER -->
          <div class="overflow-y-auto p-2">
            <div v-if="this.attachmentUrl">
              <div class="secure-frame-wrapper">
                <iframe
                  :src="this.attachmentUrl"
                  width="100%"
                  height="650"
                  frameborder="0"
                  class="secure-frame"
                  :title="docTitle"
                ></iframe>

                <!-- Invisible overlay to disable right-click/download -->
                <div class="no-download-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from '@/components/loader/loader.vue';
import { viewSecuredAttachment } from '../utils/secureAttachmentsViewer';

export default {
  name: 'AttachmentsViewer',

  props: {
    attachmentUrl: { type: String, required: true },
    token: { type: String, required: false },
    showAttachments: { type: Boolean, default: false },
    docTitle: { type: String, default: null },
  },

  components: { Loader },

  data() {
    return {
      loading: false,
      create_error: null,
      finalUrl: null,
    };
  },

  watch: {
    showAttachments(val) {
      if (val) this.loadFile();
      else this.finalUrl = null;
    },
  },

  methods: {
    async loadFile() {
      try {
        this.loading = true;
        this.create_error = null;

        const url = await viewSecuredAttachment(this.attachmentUrl, this.token);

        if (!url) {
          this.create_error = 'Failed to load document.';
          return;
        }

        // Prevent download + hide PDF toolbar
        const separator = url.includes('?') ? '&' : '?';
        this.finalUrl =
          url + separator + 'download=false#toolbar=0&navpanes=0&statusbar=0';
      } catch (err) {
        console.error(err);
        this.create_error = 'Error loading file.';
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.finalUrl = null;
      this.$emit('close');
    },
  },
};
</script>

<style>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* No download allowed */
.secure-frame-wrapper {
  position: relative;
}

.secure-frame {
  pointer-events: auto;
}

/* Overlay blocks right-click, drag, and save */
.no-download-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none; /* Does not block viewing */
  background: transparent;
}
</style>
